import { render, staticRenderFns } from "./adTemp1.vue?vue&type=template&id=d6202216&scoped=true&"
import script from "./adTemp1.vue?vue&type=script&lang=js&"
export * from "./adTemp1.vue?vue&type=script&lang=js&"
import style0 from "./adTemp1.vue?vue&type=style&index=0&id=d6202216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6202216",
  null
  
)

component.options.__file = "adTemp1.vue"
export default component.exports